import * as React from 'react';
import * as _ from "lodash";
import { connect, Dispatch } from "react-redux";
import { AxiosError } from 'axios';
import * as UrlPattern from 'url-pattern';

import {
    IApplicationState, IShortCodeState, AppActionCreators, IShortCodeActionCreators
} from "../../store";
import { IShortCodeLink, ISaveShortCodeLinkRequest, IBaseResponse } from '../../models';
import { Modal, Glyphicon, Alert, DropdownButton, MenuItem } from "react-bootstrap";
import { ISaveShortCodeLinkResponse } from '@nkr/models/save-short-code-link-response';
import { IListShortCodeLinksResponse } from '@nkr/models/list-short-code-links-response';
import ShortCodeRow from './short-code-row';

interface IOwnProps { }

interface IShortCodeStateProps {
}

interface IShortCodeDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getNewShortCode: () => Promise<IBaseResponse>,
    createShortCodeLink: (shortCode: string, link: string) => Promise<ISaveShortCodeLinkResponse>,
    listShortCodeLinks: () => Promise<IListShortCodeLinksResponse>,
    updateShortCodeLink: (id: string, isActive: boolean) => Promise<ISaveShortCodeLinkResponse>
}

type TShortCodeProps = IShortCodeStateProps & IShortCodeDispatchProps & IOwnProps

interface IState {
    shortCode: string,
    link: string,
    shortCodeLinks: IShortCodeLink[],
    // showModal: boolean,
    // modalMessage: string
    alert: {
        show: boolean,
        error: boolean,
        message: string
    }
}

class ShortCodeCreator extends React.Component<TShortCodeProps, IState> {
    readonly state: IState = {
        shortCode: "",
        link: "",
        shortCodeLinks: [],
        // showModal: false,
        // modalMessage: ""
        alert: {
            show: false,
            error: false,
            message: ""
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.props.showLoading("Getting Data...").then(() => {
            Promise.all([this.props.getNewShortCode(),
            this.props.listShortCodeLinks()
            ]).then((response: [IBaseResponse, IListShortCodeLinksResponse]) => {

                var getNewShortCodeResponse = response[0];
                var listShortCodeLinksResponse = response[1];

                if (getNewShortCodeResponse.data.success) {
                    this.setState({
                        shortCode: getNewShortCodeResponse.data.message
                    })
                }

                if (listShortCodeLinksResponse.data.success) {
                    this.setState({
                        shortCodeLinks: listShortCodeLinksResponse.data.results
                    })
                }

                this.props.hideLoading();

            }).catch(() => {
                this.props.hideLoading();
            })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    clickGetNewCode = () => {
        this.props.showLoading("Getting Data...").then(() => {
            this.props.getNewShortCode().then((response: IBaseResponse) => {
                if (response.data.success) {
                    this.setState({
                        shortCode: response.data.message
                    })

                    this.props.hideLoading();
                }
            }).catch(() => {
                this.props.hideLoading();
            })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    isValidUrl = (link: string) => {
        var pattern = new UrlPattern('(http(s)\\://)(:subdomain.):domain.:tld(\\::port)(/*)');
        var results = pattern.match(link);

        if (results != null) {
            return true;
        } else {
            return false;
        }
    }

    toggleEnable = (shortCodeLink: IShortCodeLink) => {
        let shortCodeLinks: IShortCodeLink[] = _.cloneDeep(this.state.shortCodeLinks);
        var isActive = !shortCodeLink.isActive

        this.props.showLoading("Updating").then(() => {
            this.props.updateShortCodeLink(shortCodeLink.id, isActive).then((response: ISaveShortCodeLinkResponse) => {
                if (response.data.success) {
                    shortCodeLinks = shortCodeLinks.map(x => {
                        if (x.id == shortCodeLink.id)
                            x.isActive = isActive;

                        return x;
                    });

                    this.setState({
                        shortCodeLinks: shortCodeLinks
                    })
                }
                else {
                    this.showAlert("An error occurred while attemping to save.", true);
                }

            }).catch(() => {
                this.props.hideLoading();
            })
        }).then(() => {
            this.props.hideLoading();
        })
    }

    clickSaveLink = () => {
        let link = this.state.link;
        let shortCode = this.state.shortCode;

        if (link == "") {
            this.showAlert("Please enter a url", true);
            return;
        }

        if (!this.isValidUrl(link)) {
            this.showAlert("Please enter a valid url.", true);
            return;
        }

        if (shortCode == "") {
            this.showAlert("Please select a short code", true);
            return;
        }

        this.props.showLoading("Saving...").then(() => {
            this.props.createShortCodeLink(shortCode, link).then((response: ISaveShortCodeLinkResponse) => {
                if (response.data.success) {
                    let shortCodeLinks = this.state.shortCodeLinks;
                    shortCodeLinks.push(response.data.results);

                    this.setState({
                        shortCode: "",
                        link: "",
                        shortCodeLinks: shortCodeLinks
                    })

                    this.showAlert("Short Code link has been created.", false)
                    this.props.hideLoading();
                }
                else {
                    this.showAlert(response.data.message, true);
                }
            }).catch(() => {
                this.props.hideLoading();
                this.showAlert("An error occurred while attemping to save.", true);
            })
        }).catch(() => {
            this.props.hideLoading();
            this.showAlert("An error occurred while attemping to save.", true);
        });
    }

    onChangeLink = (el: React.FormEvent<HTMLInputElement>) => {
        var elementValue: string = el.currentTarget.value

        this.setState({
            link: elementValue
        });
    }

    showAlert = (message: string, error: boolean) => {
        this.setState({
            alert: {
                show: true,
                error,
                message
            }
        });
    }

    render() {
        return (
            <div className="container">
                {this.state.alert.show && (
                    <div className={"alert " + (this.state.alert.error ? 'alert-danger' : 'alert-success')}>{this.state.alert.message}</div>
                )}

                <div style={{ marginTop: 10 }}>
                    <h3>Create New Short Code Link</h3>
                </div>
                <hr></hr>
                <div className="row" style={{ marginBottom: 10 }}>
                    <div className="col-xs-4">
                        <input type="text" className="form-control" placeholder="short code" value={this.state.shortCode} readOnly />
                    </div>
                    <div className="col-xs-6 text-left">
                        <button type="button" className="btn btn-default" onClick={this.clickGetNewCode}>Generate New Code</button>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: 10 }}>
                    <div className="col-xs-6" >
                        <input type="text" className="form-control" placeholder="url" value={this.state.link} onChange={this.onChangeLink} />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: 10 }}>
                    <div className="col-xs-6">
                        <button type="button" className="btn btn-primary" onClick={this.clickSaveLink}>Create New ShortCode Link</button>
                    </div>
                </div>
                <div style={{ marginTop: 80 }}>
                    <h3>Saved Short Codes</h3>
                </div>
                <hr></hr>
                {this.state.shortCodeLinks.map(shortCodeLink =>
                    <ShortCodeRow
                        shortCodeLink={shortCodeLink}
                        onToggleEnable={this.toggleEnable}
                    />
                )}
            </div>
        )
    }
}

const mapStateToProps = (appState: IApplicationState): IShortCodeStateProps => {
    return {}
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IShortCodeDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getNewShortCode: () => { return dispatch(IShortCodeActionCreators.getNewShortCode()); },
        createShortCodeLink: (shortCode: string, link: string) => { return dispatch(IShortCodeActionCreators.createShortCodeLink(shortCode, link)) },
        listShortCodeLinks: () => { return dispatch(IShortCodeActionCreators.listShortCodeLinks()) },
        updateShortCodeLink: (id: string, isActive: boolean) => { return dispatch(IShortCodeActionCreators.updateShortCodeLink(id, isActive)) }
    };
}

export default connect<IShortCodeStateProps, IShortCodeDispatchProps, IOwnProps>(
    mapStateToProps, mapDispatchToProps)(ShortCodeCreator)